<app-relative-date
  *ngIf="action === 'add' && metadataType === 'INSTANT'"
  [formControl]="control"
></app-relative-date>
